import RestUtilities, { IRestResponse } from "./RestUtilities";
import { WorkdayConnectivity } from '../models/IWorkdayConnectivity';

export default class WorkdayService {
  
  static async testConnectivity(wdConn: WorkdayConnectivity): Promise<IRestResponse<WorkdayConnectivity>> {
    return await RestUtilities.post<WorkdayConnectivity>("/api/workday", wdConn);
  }
}